import React, { useState } from "react"
import styled from "styled-components"
import { graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Layout from "../layouts"
import Seo from "../components/seo"
import {
BreadCrumb,
SectionPageTitle,
Section,
SectionTitle,
SectionDescription,
Container,
ProductList,
ProductItem,
ExploreMore,
MarkdownContent
} from "../components/Section"
import Content, { HTMLContent } from '../components/Content';
import ProductCard from "../components/ProductCard";
import RoofStyle from "../components/RoofStyle";
import generateHTML from '../utils/generateHTML';
import AvailableSection from "../sections/Category/AvailableSection";
import CtaSection from '../sections/CtaSection';
import PrimaryButton from "../components/Button/PrimaryButton";

const HeroImagesWrapeer = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: 20px;
	margin: 64px auto -150px;

	@media(max-width:768px) {
		grid-template-columns: repeat(1, 1fr);
		margin-bottom: 50px;
	}
`
const HeroImage = styled.div`
	width: 100%;
	height: 100%;
	.gatsby-image-wrapper {
		width: 100%;
		height: 100%;
	}
	@media(max-width:768px) {
		height: 300px;
	}
`

const SubCategoryLandingTemplate = ({ data, location }) => {
  const [showLimit, setShowLimit] = useState(9);
	const pageData = data.contentfulSubCategoryLanding;
	const PostContent = HTMLContent || Content;

	let currentSubCategoryProduct = []
	data.allContentfulProduct.edges.forEach(function(item) {
		if (item.node.subCategory?.name === pageData.subCategory.name) {
			currentSubCategoryProduct.push(item.node);
		}
	})
	const availableSectionData = {
		title: pageData.availableSectionTitle,
		description: pageData.availableSectionDescription,
		sizes: pageData.availableSizes
	}
	return (
		<Layout footerCta location={location}>
			<Seo title={pageData.metaTitle} description={pageData.metaDescription} />
			<Section ept="160px" xpt="140px" pt="80px" bgColor="#fff">
				<Container>
					<BreadCrumb position="relative">
						<Link to="/">Home</Link>
						<Link to={pageData.subCategory.category.url}>{pageData.subCategory.category.name}</Link>
						<span>{pageData.subCategory.name}</span>
					</BreadCrumb>
					<SectionPageTitle>{pageData.heroTitle}</SectionPageTitle>
					<SectionDescription maxWidth="1220px">
						<div dangerouslySetInnerHTML={{__html: pageData.heroDescription.childMarkdownRemark.html}} />
					</SectionDescription>

					{ pageData.subCategory.category.name!=="Steel Buildings" && pageData.subCategory.category.name!=="Portable Buildings" && (
						<HeroImagesWrapeer>
							<HeroImage>
								<GatsbyImage image={getImage(pageData.heroImages[0].gatsbyImageData)} alt="Buildings And More" />
							</HeroImage>
							<HeroImage>
								<GatsbyImage image={getImage(pageData.heroImages[1].gatsbyImageData)} alt="Buildings And More" />
							</HeroImage>
						</HeroImagesWrapeer>
					)}	
				</Container>
			</Section>
			<Section bgColor="#EFF3F8" pt={pageData.subCategory.category.name!=="Steel Buildings" && pageData.subCategory.category.name!=="Portable Buildings" ? "200px": "100px"}>
				<Container>
					<SectionTitle mb="30px">{pageData.productSectionTitle}</SectionTitle>
					<ProductList>
						{currentSubCategoryProduct.map((product, i) => i < showLimit && (
								<ProductItem><ProductCard data={product} key={`product-${i}`} /></ProductItem>
							)
						)}
					</ProductList>
					{currentSubCategoryProduct.length > showLimit && (
						<ExploreMore>
							<button type="button" onClick={()=>setShowLimit(showLimit + 6)}><PrimaryButton text="Load More Buildings" size="lg" /></button>								
						</ExploreMore>
					)}
				</Container>
			</Section>

			{pageData.availableSectionDescription && (
				<AvailableSection data={availableSectionData} />
			)}
			{pageData.subCategory.category.name !== "Portable Buildings" && (
				<RoofStyle />
			)}
			{pageData.subCategory.category.name !== "Portable Buildings" && (
				<CtaSection mb="0" />
			)}
			{pageData.content && (
				<Section>
					<Container maxWidth="1220px">
						<MarkdownContent>
							<PostContent content={generateHTML(pageData.content.childMarkdownRemark.html)} />
						</MarkdownContent>
					</Container>
				</Section>
			)}
	</Layout>
	)
}

export default SubCategoryLandingTemplate;

export const pageQuery = graphql`
  query subCategoryLandingTemplate($id: String!) {
    contentfulSubCategoryLanding(id: { eq: $id }) {
      metaTitle
      metaDescription
      subCategory {
      	name
      	
      	category {
      		name
      		url
      	}
      }
      heroTitle
	    heroDescription {
	      childMarkdownRemark {
	    		html
	    	}
	    }
	    heroImages {
        gatsbyImageData(placeholder: BLURRED, quality: 90)
      }
	    productSectionTitle
	    availableSectionTitle
	    availableSectionDescription {
	      childMarkdownRemark {
	        html
	      }
	    }
	    availableSizes {
	      content
	    }
	    content {
	    	childMarkdownRemark {
	    		html
	    	}
	    }
    }
	  allContentfulProduct {
      edges {
        node {
          category {
            name
          }
          subCategory {
          	name
          }
          name
          sku
          width
          length
          height
          image {
            gatsbyImageData(placeholder: BLURRED, quality: 50)
          }
          startingPrice
          downPayment
          url
        }
      }
    }
  }
`